import { useCallback } from "react";

import { useFetchMutation } from "common/queries/hooks";
import { GenerateOrderPdf } from "common/types/pdfs";

import { urls } from "./constants";

export const useGenerateOrderPdfMutation = (openPrintModal = true) => {
  const { mutateAsync, isPending: isLoading } = useFetchMutation<GenerateOrderPdf, Blob>({
    fetch: (body) => ({
      url: urls.generateOrderPdf(),
      method: "POST",
      body,
      responseContentType: "application/pdf",
    }),
  });

  const mutate = useCallback(
    (body: GenerateOrderPdf) => {
      // Open window synchronously within the user gesture context.
      // Safari (especially on iPad) blocks window.open() calls in async
      // callbacks because the user gesture context is lost after the fetch.
      const pdfWindow = window.open("about:blank");

      mutateAsync(body)
        .then((resp) => {
          const url = window.URL.createObjectURL(resp);

          if (!pdfWindow || pdfWindow.closed) {
            return;
          }

          pdfWindow.location.href = url;
          pdfWindow.focus();

          if (openPrintModal) {
            pdfWindow.addEventListener("load", () => {
              pdfWindow.print();
            });
          }
        })
        .catch(() => {
          // TODO sc-27587: Port over toasts and consume here to give feedback when this fails
          pdfWindow?.close();
        });
    },
    [mutateAsync, openPrintModal],
  );

  return { mutate, isLoading };
};
